import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../i18n";
import { IMAGES, scrollTo } from "../../utils";
import { Reveal } from "./Section";

const About = () => {
  const { t } = useLang();
  return (
    <section id="entreprise" className="border-y border-[#232733] bg-[#111318] scroll-mt-16" data-testid="about-section">
      <div className="grid lg:grid-cols-2">
        <div className="px-6 lg:px-14 py-16 lg:py-28">
          <Reveal>
            <div className="flex items-center gap-4">
              <span className="font-mono text-xs text-[#0055FF] tracking-widest">05</span>
              <span className="h-px w-10 bg-[#0055FF]" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#647087]">{t.about.overline}</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-tighter text-white mt-6 leading-[0.95]">
              {t.about.title}
            </h2>
            <p className="text-base md:text-lg text-[#A0AABF] mt-8 leading-relaxed">{t.about.p1}</p>
            <p className="text-base text-[#A0AABF] mt-4 leading-relaxed">{t.about.p2}</p>
            <button
              data-testid="about-quote-btn"
              onClick={() => scrollTo("#devis")}
              className="group flex items-center gap-3 border border-[#0055FF] text-[#4D8BFF] font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 mt-10 hover:bg-[#0055FF] hover:text-white transition-colors"
            >
              {t.about.cta}
              <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </button>
          </Reveal>
          <div className="grid sm:grid-cols-3 gap-px bg-[#232733] border border-[#232733] mt-14">
            {t.about.highlights.map((h, i) => (
              <Reveal key={i} delay={i * 0.08} className="bg-[#0A0B0E]">
                <div className="p-6">
                  <div className="font-display text-lg font-medium tracking-tight text-white">{h.value}</div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#647087] mt-2">{h.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="relative min-h-[360px] lg:min-h-0 border-t lg:border-t-0 lg:border-l border-[#232733] overflow-hidden">
          <Reveal className="absolute inset-0" y={0}>
            <img src={IMAGES.factory} alt="Usine K&K" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale-[25%] hover:grayscale-0 transition-all duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E]/70 via-transparent to-transparent" />
            <span className="absolute bottom-6 left-6 font-mono text-[10px] uppercase tracking-[0.2em] text-[#A0AABF] bg-[#0A0B0E]/70 backdrop-blur px-3 py-1.5 border border-[#232733]" data-testid="about-image-note">
              {t.about.note}
            </span>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
